import { NEXT_PUBLIC_HOST_NAME } from '@app/core-features/env/env-shared';

import { getUrlPathWithSearch } from '@/core/utils/url';

/**
 * Check if a link click is handled by our link component
 * or if it is a link that is an internal link and should be handled by the router
 */
export const getUnhandledInternalLink = (target: EventTarget | null): null | string => {
    if (!(target instanceof HTMLElement)) {
        return null;
    }

    const link = target.closest('a');

    if (!(link instanceof HTMLAnchorElement)) {
        return null;
    }

    if (link.getAttribute('class')?.includes('linkComponent')) {
        return null;
    }

    if (link.getAttribute('target') === '_blank') {
        return null;
    }

    const href = link.getAttribute('href');
    if (!href) {
        return null;
    }

    const isInternalLink =
        href.indexOf(NEXT_PUBLIC_HOST_NAME ?? '___') === 0 || (href.indexOf('/') === 0 && href.indexOf('//') !== 0);
    if (isInternalLink) {
        return getUrlPathWithSearch(href);
    }

    return null;
};
